/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Coach_Open_OneInputs */

const en_hero_coach_open_one = /** @type {(inputs: Hero_Coach_Open_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 open time this week`)
};

const pl_hero_coach_open_one = /** @type {(inputs: Hero_Coach_Open_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 wolny termin w tym tygodniu`)
};

/**
* | output |
* | --- |
* | "1 open time this week" |
*
* @param {Hero_Coach_Open_OneInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_coach_open_one = /** @type {((inputs?: Hero_Coach_Open_OneInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Coach_Open_OneInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_coach_open_one(inputs)
	return en_hero_coach_open_one(inputs)
});